/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import dtm from 'scripts/services/dtm';

export const FooterModule = BaseControl.extend({
    init() {
        this._super();
    },

    '.s-partners-list a.link click': function ($el) {
        const partnerName = $el.attr('title');
        if (partnerName) {
            dtm.trackFooterPartnerClick(partnerName);
        } else {
            console.error('Partner name is not defined');
        }
    },

    '.s-social-media a.s-link click': function ($el) {
        const socialMediaName = $el.attr('title');
        if (socialMediaName) {
            dtm.trackFooterSocialMediaClick(socialMediaName);
        } else {
            console.error('Social media name is not defined');
        }
    },

    '.s-nav a.s-nav-item__link  click': function ($el) {
        const navName = $el.attr('title');
        if (navName) {
            dtm.trackFooterNavNameClick(navName);
        } else {
            console.error('Nav media name is not defined');
        }
    },

    '.s-apps a.s-app-btn click': function ($el, event) {
        const platform = (event.target.className.indexOf('android') > -1) ? 'android' : 'ios';
        const parentItem = $el.closest('div[data-index]');
        const index = parseInt(parentItem.data('index')) + 1;
        const appName = `${index}:${platform}`;

        dtm.trackFooterAppDownloadClick(appName);
    }
});
